import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, ArrowUpRight } from 'lucide-react';
import { offices, CTA_URL } from '../mock';
import { useI18n } from '../i18n/I18nContext';

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer className="relative mt-24 border-t border-blue-500/10 bg-white">
      <div className="absolute inset-x-0 -top-px h-px bg-gradient-to-r from-transparent via-blue-500/50 to-transparent" />
      <div className="mx-auto max-w-7xl px-5 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          <div className="space-y-5 sm:col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2.5">
              <img src="/logo-icon.png" alt="Leadeverest" className="h-10 w-auto object-contain shrink-0" />
              <span className="font-display text-xl leading-none font-semibold text-slate-900 whitespace-nowrap">Leadeverest</span>
            </Link>
            <p className="text-sm text-slate-700/60 leading-relaxed max-w-xs">
              {t('footer.description')}
            </p>
            <a href={CTA_URL} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-sm text-blue-600 hover:text-blue-500 transition-colors">
              {t('common.free_consultation')} <ArrowUpRight className="h-4 w-4" />
            </a>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.18em] text-blue-600 mb-4">{t('footer.nav_label')}</h4>
            <ul className="space-y-3 text-sm text-slate-700">
              <li><Link to="/" className="hover:text-slate-900 transition-colors">{t('nav.home')}</Link></li>
              <li><Link to="/services" className="hover:text-slate-900 transition-colors">{t('nav.services')}</Link></li>
              <li><a href="/#rolunk" className="hover:text-slate-900 transition-colors">{t('nav.about')}</a></li>
              <li><a href="/#referenciak" className="hover:text-slate-900 transition-colors">{t('nav.references')}</a></li>
              <li><a href="/#kapcsolat" className="hover:text-slate-900 transition-colors">{t('nav.contact')}</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.18em] text-blue-600 mb-4">{t('footer.contact_label')}</h4>
            <ul className="space-y-3 text-sm text-slate-700">
              <li className="flex items-start gap-2"><Mail className="h-4 w-4 text-blue-500 mt-0.5" /><a href="mailto:antonia@leadeverest.eu" className="hover:text-slate-900">antonia@leadeverest.eu</a></li>
              <li className="flex items-start gap-2"><Mail className="h-4 w-4 text-blue-500 mt-0.5" /><a href="mailto:antal@leadeverest.eu" className="hover:text-slate-900">antal@leadeverest.eu</a></li>
              <li className="flex items-start gap-2"><Phone className="h-4 w-4 text-blue-500 mt-0.5" /><a href="tel:+421917705884" className="hover:text-slate-900">+421 917 705 884</a></li>
              <li className="flex items-start gap-2"><Phone className="h-4 w-4 text-blue-500 mt-0.5" /><a href="tel:+36703693173" className="hover:text-slate-900">+36 70 369 3173</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.18em] text-blue-600 mb-4">{t('footer.offices_label')}</h4>
            <ul className="space-y-3 text-sm text-slate-700">
              {offices.map((o, i) => (
                <li key={i} className="flex items-start gap-2">
                  <MapPin className="h-4 w-4 text-blue-500 mt-0.5" />
                  <span><span className="mr-1">{o.flag}</span>{o.label} · {o.address}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-blue-500/10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} Leadeverest {t('footer.rights')}</div>
          <div className="flex items-center gap-4">
            <span>Company ID: 55 100 376</span>
            <span className="h-1 w-1 rounded-full bg-blue-500/50" />
            <span>Sabinovska 9., Bratislava 831 04, Slovakia</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
